import { render, staticRenderFns } from "./ClassroomDetailTabMyTasksList.vue?vue&type=template&id=a08fe49e&scoped=true"
import script from "./ClassroomDetailTabMyTasksList.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTabMyTasksList.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailTabMyTasksList.vue?vue&type=style&index=0&id=a08fe49e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08fe49e",
  null
  
)

export default component.exports